export default "__VITE_ASSET__C3aJWZi6__"